import React, { createContext, useContext, useState, useEffect } from 'react';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    // Load language from localStorage if available
    return localStorage.getItem('ambtu-language') || 'es';
  });

  // Force re-render when language changes
  const [renderKey, setRenderKey] = useState(0);

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setRenderKey(prev => prev + 1);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => {
      window.removeEventListener('languageChanged', handleLanguageChange);
    };
  }, []);

  const t = (key) => {
    const keys = key.split('.');
    let translation = translations[currentLanguage];
    
    for (const k of keys) {
      if (translation && translation[k]) {
        translation = translation[k];
      } else {
        // Fallback to Spanish if translation not found
        translation = translations['es'];
        for (const fallbackKey of keys) {
          if (translation && translation[fallbackKey]) {
            translation = translation[fallbackKey];
          } else {
            return key; // Return key if no translation found
          }
        }
        break;
      }
    }
    
    return translation || key;
  };

  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
    // Force re-render by storing language in localStorage
    localStorage.setItem('ambtu-language', langCode);
    // Trigger custom event to force component updates
    window.dispatchEvent(new CustomEvent('languageChanged', { detail: langCode }));
  };

  return (
    <LanguageContext.Provider value={{
      currentLanguage,
      changeLanguage,
      t,
      renderKey // Provide render key to force updates
    }}>
      {children}
    </LanguageContext.Provider>
  );
};